import React, { lazy } from "react";

const AlertLog = lazy(() => import("./index"));

const AlertLogRoute = () => {
    return [];
};

export default AlertLogRoute;
